import * as THREE from 'three';
import {Text, preloadFont} from 'troika-three-text';
import '../utils/date';
import { AxesHelper } from 'three';

const sourcePath = (typeof globalPath !== 'undefined')?globalPath:'';

export default class TextSpriteTimer{

    constructor(){

        //this.font = './test/helvetiker_bold.typeface.json';
        //this.font = './test/HSSantokki-Regular.otf';
        this.font = sourcePath+'./fonts/Lato-Thin.ttf';
        this.color = 0xffffff;
        this.mesh = null;
        this.dday = null;
        
        //연산에 사용
        this.date = new Date();

        preloadFont(
            {
                font:this.font,
                characters: '0123456789:.'
            },
            (e) => {
                //console.log('preloadFont.onComplete', e);
            }
        );

        this.mesh = this.create('-- : -- : -- : --');
        
        //
        const font2 = sourcePath+'./fonts/Lato-Regular.ttf';
        const size = 0.15;
        this.allMeshes = [
            this.mesh,
            this.create('DAYS', size, {x:-2.2, y:-0.5, z:0}, font2),
            this.create('HOURS', size, {x:-0.7, y:-0.5, z:0}, font2),
            this.create('MINS', size, {x:0.7, y:-0.5, z:0}, font2),
            this.create('SECONDS', size, {x:2.1, y:-0.5, z:0}, font2),
        ];
    }


    create(text, size = 0.8, position = null, font = null){

        font = font ? font : this.font;
        
        const textMesh = new Text();
        textMesh.name = 'TextSprite';
        textMesh.material.side = THREE.FrontSide;

        textMesh.text = text;
        textMesh.textAlign = 'center';
        textMesh.fontSize = size;
        textMesh.anchorX = 'center';
        textMesh.anchorY = 'middle';
        textMesh.color = this.color;
        textMesh.font = font;
        textMesh.sync();

        position && textMesh.position.copy(position);

        return textMesh;
    }



    setDDay(year, month, date, hour = 0, minute = 0, second = 0){
        this.dday = new Date(year, month-1, date, hour, minute, second);
        this._startTimer();
    }


    _startTimer = () => {
        
        setInterval(() => {
            
            if(!this.dday){
                return;
            }

            //
            let seconds = this.dday.getTime() - Date.now();
            seconds /= 1000;

            let days = Math.floor(seconds / DAY_SEC);
            seconds %= DAY_SEC;

            let hours = Math.floor(seconds / HOUR_SEC);
            seconds %= HOUR_SEC;

            let min = Math.floor(seconds / MIN_SEC);
            seconds %= MIN_SEC;

            seconds = Math.floor(seconds);

            //
            days = String(days).padStart(2, '0');
            hours = String(hours).padStart(2, '0');
            min = String(min).padStart(2, '0');
            seconds = String(seconds).padStart(2, '0');

            this.mesh.text = `${days} : ${hours} : ${min} : ${seconds}`;

        }, 1000);
    }
}


const MIN_SEC = 60;
const HOUR_SEC = MIN_SEC * 60;
const DAY_SEC = HOUR_SEC * 24;